class Campo {
    constructor(input, etiqueta, visibilidad, obligatorio) {
        this.input = input;
        this.etiqueta = etiqueta;
        this.visibilidad = visibilidad;
        this.obligatorio = obligatorio;
    }
}
const buscaCampoDeEtiqueta = (etiqueta) => {
    const atributoFor = etiqueta.getAttribute('for');
    if (atributoFor) {
        return document.getElementById(atributoFor);
    }
    return null;
}, buscaCampos = (formulario) => {
    const campos = {}, etiquetas = formulario.querySelectorAll(`.campo label`);
    [].forEach.call(etiquetas, function (etiqueta) {
        let input = buscaCampoDeEtiqueta(etiqueta);
        if (input) {
            const padre = input.parentNode;
            if (padre) {
                const campo = new Campo(input, etiqueta.cloneNode(true), JSON.parse(padre.getAttribute('data-visibilidad') || '{}'), input.required);
                campos[input.id] = campo;
            }
        }
    });
    return campos;
}, configuraEtiquetas = (formulario) => {
    const campos = {}, etiquetas = formulario.querySelectorAll(`.campo:not(.campo--checkbox) > label`);
    [].forEach.call(etiquetas, function (etiqueta) {
        var _a;
        let input = buscaCampoDeEtiqueta(etiqueta);
        if (input && !input.getAttribute('placeholder')) {
            const padre = input.parentNode;
            if (padre) {
                const campo = new Campo(input, etiqueta, JSON.parse(padre.getAttribute('data-visibilidad') || '{}'), input.required);
                campos[input.id] = campo;
                if (((_a = campo.input.value) === null || _a === void 0 ? void 0 : _a.trim()) === '') {
                    etiqueta.classList.add('is-inactiva');
                }
            }
        }
    });
    formulario.addEventListener('blur', function (e) {
        var _a;
        const input = e.target, campo = campos[input.id];
        if (campo && !((_a = campo.input.value) === null || _a === void 0 ? void 0 : _a.trim()) && !campo.input.classList.contains('con-archivo')) {
            campo.etiqueta.classList.add('is-inactiva');
            if (campo.input.getAttribute('type') === 'date') {
                campo.input.style.color = 'transparent';
            }
        }
    }, true);
    formulario.addEventListener('focus', function (e) {
        const input = e.target, campo = campos[input.id];
        if (campo) {
            campo.etiqueta.classList.remove('is-inactiva');
            if (campo.input.getAttribute('type') === 'date') {
                campo.input.style.color = 'currentColor';
            }
        }
    }, true);
    return campos;
}, reinicia = (campos) => {
    Object.keys(campos).forEach(key => {
        const { input, etiqueta } = campos[key];
        if (!input.value || input.value.trim() === '') {
            etiqueta.classList.add('is-inactiva');
            if (input.getAttribute('type') === 'date') {
                input.style.color = 'transparent';
            }
        }
    });
}, configuraSubmit = (formulario, opciones) => {
    const submit = formulario.querySelector('[type="submit"]');
    const enviado = opciones.enviado || (() => {
    });
    const offset = opciones.offset || (() => 0);
    const dataLayer = opciones.dataLayer;
    formulario.addEventListener('submit', e => {
        e.preventDefault();
        submit.disabled = true;
        let promesa = Promise.resolve();
        if (window.recaptcha) {
            promesa = new Promise(resolve => {
                window.grecaptcha.enterprise.ready(async () => {
                    const token = await window.grecaptcha.enterprise.execute(window.recaptcha, { action: 'submit' });
                    const input = formulario.querySelector('input[name="g-recaptcha-response"]') || document.createElement('input');
                    input.setAttribute('type', 'hidden');
                    input.setAttribute('name', 'g-recaptcha-response');
                    input.setAttribute('value', token);
                    formulario.appendChild(input);
                    resolve();
                });
            });
        }
        promesa.then(() => {
            fetch(formulario.getAttribute('action') || location.href, {
                method: 'post',
                body: new FormData(formulario)
            })
                .then(x => {
                if (x.redirected) {
                    enviado(formulario);
                    dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({
                        event: 'formulario-enviado',
                        formulario: formulario.id
                    });
                    location.href = x.url;
                }
                return x.text();
            })
                .then(text => (new DOMParser()).parseFromString(text, 'text/html'))
                .then(dom => {
                const f = dom.querySelector(`#${formulario.getAttribute('id')}`);
                if (f) {
                    formulario.parentElement.replaceChild(f, formulario);
                    inicializaFormulario(f, opciones);
                }
                window.scrollTo(0, formulario.getBoundingClientRect().top + scrollY - offset());
                formulario.classList.add('enviado');
                if (!formulario.querySelector('input')) {
                    enviado(formulario);
                    dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({
                        event: 'formulario-enviado',
                        formulario: formulario.id
                    });
                }
            })
                .finally(() => submit.disabled = false);
        });
    });
}, actualizaVisibilidad = (campos, formulario) => () => {
    const datos = new FormData(formulario), nombre = formulario.getAttribute('data-nombre');
    Object.values(campos).forEach(campo => {
        const erroneos = Object.keys(campo.visibilidad).filter(key => {
            return campo.visibilidad[key] !== datos.get(`${nombre}[${key}]`);
        });
        if (erroneos.length === 0) {
            campo.input.required = campo.obligatorio;
            campo.input.parentElement.style.display = '';
        }
        else {
            campo.input.required = false;
            campo.input.parentElement.style.display = 'none';
        }
    });
}, configuraVisibilidad = (campos, formulario) => {
    const actualizador = actualizaVisibilidad(campos, formulario);
    formulario.addEventListener('change', actualizador);
    actualizador();
}, ajustaObligatorios = (campos, formulario) => {
    const nombreBase = formulario.getAttribute('data-nombre');
    formulario.addEventListener('change', () => {
        Object.keys(campos).forEach(key => {
            const { input, etiqueta } = campos[key], condiciones = JSON.parse(input.getAttribute('data-required') || '{}');
            if (Object.keys(condiciones).length > 0) {
                const obligatorio = Object.keys(condiciones).reduce((valido, claveDelOtro) => {
                    const otro = document.getElementById(`${nombreBase}-${claveDelOtro}`);
                    return valido && (!otro || otro.value === condiciones[claveDelOtro]);
                }, true);
                input.required = obligatorio;
                if (obligatorio && etiqueta.textContent.indexOf('*') === -1) {
                    etiqueta.textContent += ' *';
                }
                else if (!obligatorio && etiqueta.textContent.indexOf('*') !== -1) {
                    etiqueta.textContent = etiqueta.textContent.replace(' *', '');
                }
            }
        });
    }, true);
}, configuraArchivos = (campos) => {
    Object.keys(campos)
        .filter(clave => campos[clave].input.type === 'file')
        .map(x => campos[x])
        .forEach(archivo => {
        const { input, etiqueta } = archivo, campo = input.closest('.campo');
        if (campo) {
            const texto = document.createElement('div');
            texto.innerHTML = '&nbsp;';
            campo.appendChild(texto);
            campo.addEventListener('drop', ev => {
                var _a;
                ev.preventDefault();
                if ((_a = ev.dataTransfer) === null || _a === void 0 ? void 0 : _a.files) {
                    input.files = ev.dataTransfer.files;
                    campo.classList.add('con-archivo');
                    texto.textContent = input.files[0].name;
                    etiqueta.classList.remove('is-inactiva');
                }
            });
            campo.addEventListener('dragover', e => {
                campo.classList.add('archivo-encima');
                e.preventDefault();
            });
            campo.addEventListener('dragleave', e => {
                campo.classList.remove('archivo-encima');
            });
            input.addEventListener('change', e => {
                const nombre = input.value.split('\\').pop();
                if (nombre) {
                    texto.textContent = nombre;
                }
            });
        }
    });
};
const inicializaFormulario = (formulario, opciones) => {
    var _a;
    if (!formulario || formulario.classList.contains('inicializado')) {
        return;
    }
    formulario.classList.add('inicializado');
    const todosLosCampos = buscaCampos(formulario);
    if (opciones.ocultarEtiquetas) {
        configuraEtiquetas(formulario);
    }
    configuraSubmit(formulario, opciones);
    configuraArchivos(todosLosCampos);
    configuraVisibilidad(todosLosCampos, formulario);
    ajustaObligatorios(todosLosCampos, formulario);
    reinicia(todosLosCampos);
    (_a = opciones.onInicializado) === null || _a === void 0 ? void 0 : _a.call(opciones, formulario);
};
export default function formulario(selector, opciones) {
    opciones = {
        offset: () => 0,
        ocultarEtiquetas: true,
        ...opciones,
    };
    [].forEach.call(document.querySelectorAll(selector), (formulario) => {
        inicializaFormulario(formulario.closest('form'), opciones);
    });
}
